import React from 'react';
import PropTypes from 'prop-types';

import Track from './Track';

const Tracks = ({ time, tracks, clickElement, onDragStart, dragAndDropReservation, onDrop, onCellClick }) => (
    <div className="rt-tracks">
        {tracks.map(({ id, elements, isOpen, tracks: children , room}) => (
            <Track
                onDragStart={onDragStart}
                dragAndDropReservation={dragAndDropReservation}
                onDrop={onDrop}
                key={id}
                time={time}
                elements={elements}
                isOpen={isOpen}
                tracks={children}
                clickElement={clickElement}
                room={room}
                onCellClick={onCellClick}
            />
        ))}
    </div>
);

Tracks.propTypes = {
    time: PropTypes.shape({}).isRequired,
    tracks: PropTypes.arrayOf(PropTypes.shape({})),
    clickElement: PropTypes.func,
};

export default Tracks;
